'use client';

import { Progress as ProgressPrimitive } from 'radix-ui';

import { cn } from '@/lib/utils';

interface IProgressProps {
    value: number;
    className?: string;
    /** Accessible name for the progressbar — screen readers announce it with the value. */
    'aria-label'?: string;
    /** Fill colour override, for a bar whose hue carries meaning (e.g. success / error). */
    indicatorClassName?: string;
}

function Progress({
    value,
    className,
    'aria-label': ariaLabel,
    indicatorClassName,
}: IProgressProps) {
    const clamped = Math.min(100, Math.max(0, value));
    return (
        <ProgressPrimitive.Root
            data-slot="progress"
            aria-label={ariaLabel}
            className={cn(
                'bg-bg-raised relative h-2 w-full overflow-hidden rounded-full',
                className,
            )}
            value={clamped}
        >
            <ProgressPrimitive.Indicator
                data-slot="progress-indicator"
                className={cn(
                    'bg-primary h-full w-full flex-1 rounded-full transition-transform duration-500 motion-reduce:transition-none',
                    indicatorClassName,
                )}
                style={{ transform: `translateX(-${100 - clamped}%)` }}
            />
        </ProgressPrimitive.Root>
    );
}

export { Progress };
export type { IProgressProps };
